import {
  type FieldError,
  type FieldErrorsImpl,
  type Merge,
} from 'react-hook-form'

export const ERROR_DICT: Record<string, string> = {
  required: 'Обязательное поле',
  email: 'Введите корректный email',
  passwordsMatches: 'Пароли не совпадают',
  passwordsShouldNotMatches: 'Новый не должен совпадать с текущим',
  passwordMinLength: 'Пароль должен быть не менее 6 символов',
  phone: 'Введите корректный телефонный номер',
  snils: 'Введите корректный СНИЛС',
  maxLength: 'Превышено максимальное количество символов',
  time: 'Некорректное время',
  telegram: 'Введите корректный username',
}

const errorDict = (
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined,
): string => {
  if (typeof error === 'undefined') return ''

  const { type } = error
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return ERROR_DICT[type] ?? 'Неверное поле'
}

export { errorDict }
